export default "__VITE_ASSET__922d535e__"